
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface StructuredDataTagsProps {
  structuredData: any[];
}

const StructuredDataTags: React.FC<StructuredDataTagsProps> = ({ structuredData }) => {
  return (
    <Helmet>
      {structuredData.map((data, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(data, null, 0)}
        </script>
      ))}
    </Helmet>
  );
};

export default StructuredDataTags;
